/**
 * Datepicker - Dynamic Load
 * Responsible for determining if the datepicker needs to load, and for actually loading the files.
 */

//
// Utilities
import debug from "debug";

//
// Dependencies
import * as services from '@core/services';
import * as registry from '@core/registry';

//
// Constants
const MODULE_NAME = registry.DATEPICKER_MODULE;
const log = debug(MODULE_NAME);

const MODULE_SELECTOR = 'input[type="date"]';
const ASSETS = [
	'../styles/nt-datepicker.module.css',
	'../scripts/nt-datepicker.module.js',
];

//
// Load
export default function load() {

	if (!services.polyfillFlags.useDateFieldPolyFill) {
		log('Polyfill not required.');
		return;
	}

	registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}



// WEBPACK FOOTER //
// ./project/client/src/site__nt/modules/datepicker/dynamic-load.js